import NetworkLogic from "../../Shared/NetworkLogic";
import find = cc.find;
import Player from "../../Models/Player";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;
const i18n = require('LanguageData');

@ccclass
export default class ScoreCheck extends cc.Component {
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Node)
    item: cc.Node = null;
    @property(cc.Node)
    empty: cc.Node = null;
    @property(cc.Prefab)
    scoreDetails: cc.Prefab = null;
    @property(cc.EditBox)
    editBox: cc.EditBox = null;
    private secondData = {};
    private data =null;
    /**
     * "data": [
     {
			"myValidBetNumber": 0,
			"newSubordinateReturnNumber": 0,
			"newTeamTotalNumber": 0,
			"noSubordinateReturnMoney": 0,
			"returnAllMoney": 0,
			"stlmDate": "",
			"subordinateReturnMoney": 0,
			"subordinateReturnNumber": 0,
			"subordinateValidBetNumber": 0,
			"teamTotalNumber": 0,
			"userId": ""
		}
     ],
     * @param event
     * @param param
     */
    onLoad () {
        this.content.getChildByName("sp0").active = false;
    }

    start () {
        this.check("");
    }
    check(userId){
        for (let i = 0;i< this.content.children.length;i++){
            this.content.children[i].active = false;
        }
        let data = {
            "gameType": 0,
            "stlmDate": "",
            "userId": userId
        };
        UIManager.showLoadingUI();
        NetworkLogic.agentPerformance(data,1,9999, function (re) {
            UIManager.hideLoadingUI();
            console.log("===收到直属业绩re：", re);
            this.data = re;
            this.showItem(re);
        }.bind(this),function () {
            console.log("===直属业绩错误");
        }.bind(this));
    };
    showItem(re){
        if (re.length > 0){
            this.empty.active = false;
        }
        else {
            this.empty.active = true;
        }
        for (let i = 0; i < re.length; i++) {
            if (this.content.children.length > re.length){
                for (let i = re.length;i < this.content.children.length;i++ ){
                    this.content.children[i].active = false;
                }
            }
            let child = null;
            if (i < this.content.children.length){
                child = this.content.children[i];
            }
            else{
                child = cc.instantiate(this.item);
                child.parent = this.content;
            }
            child.getChildByName("bg").getComponent(cc.Sprite).spriteFrame = (i % 2 === 0 ? this.sp1 : this.sp2);
            child.getChildByName("labName").getComponent(cc.Label).string = re[i].stlmDate;
            child.getChildByName("labTotal").getComponent(cc.Label).string = re[i].newSubordinateReturnNumber;
            child.getChildByName("labRat").getComponent(cc.Label).string = re[i].newTeamTotalNumber;
            child.getChildByName("labMoney").getComponent(cc.Label).string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) +  re[i].subordinateReturnMoney;
            child.getChildByName("labMoney copy").getComponent(cc.Label).string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) +  re[i].noSubordinateReturnMoney;
            child.getChildByName("labTotalReturn").getComponent(cc.Label).string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) +  re[i].returnAllMoney;
            child.getChildByName("New Button").getComponent(cc.Button).clickEvents[0].customEventData =re[i].stlmDate + "," + re[i].userId;
            child.active = true;
        }
    }


    onBtnClick(event,param){
        AudioManager.playSound("button");
        if (param === "cx"){
            this.check(this.editBox.string);

        }
        else  if (param === "cz"){
            this.editBox.string = "";
            this.check("");
        }

    }
    onDetailsClick(event,param){
        AudioManager.playSound("button");
        let arrParam = param.split(",");
        let scoreDetails  = cc.instantiate(this.scoreDetails);
        scoreDetails.parent = cc.Canvas.instance.node;
        let scriptScroeDetails = scoreDetails.getComponent("ScoreDetails");
        scriptScroeDetails.userID = arrParam[1];
        scriptScroeDetails.stlmDate = arrParam[0];
        scriptScroeDetails.checkUpdate();
        //scriptScroeDetails.onTitleClick(null,1);

    }

}
